var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: _vm.tab } },
    [
      _c(
        "v-card",
        {
          staticClass: "v-application appointments-overview",
          attrs: { disabled: _vm.isLoading },
        },
        [
          _c(
            "v-card-title",
            [
              !_vm.isPharmacy
                ? _c("v-text-field", {
                    staticClass: "search-appointments",
                    attrs: {
                      "append-icon": "mdi-magnify",
                      placeholder: "Suche nach Datum, Name der Apotheke",
                      "single-line": "",
                      "hide-details": "",
                      clearable: "",
                      autofocus: "",
                    },
                    model: {
                      value: _vm.search,
                      callback: function ($$v) {
                        _vm.search = $$v
                      },
                      expression: "search",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-data-table", {
            staticClass: "v-application--is-ltr",
            attrs: {
              headers: _vm.headers,
              items: _vm.tableRows,
              "mobile-breakpoint": "670",
              "items-per-page": 25,
              page: _vm.pageNumber,
              options: _vm.tableOptions,
              "no-data-text": "Keine Suchergebnisse",
              "server-items-length": _vm.appointmentsCount,
              loading: _vm.isLoading,
              "loading-text": "Wird geladen...",
              "show-expand": "",
              expanded: _vm.expanded,
              "item-key": "group_id",
              "hide-default-footer": "",
            },
            on: {
              "update:page": function ($event) {
                _vm.pageNumber = $event
              },
              "update:options": [
                function ($event) {
                  _vm.tableOptions = $event
                },
                _vm.onOptionsChange,
              ],
              "toggle-select-all": _vm.onSelectAll,
              "update:expanded": function ($event) {
                _vm.expanded = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "item",
                fn: function ({ item, expand, isExpanded }) {
                  return [
                    _c("TableRow", {
                      key: item.group_id,
                      attrs: {
                        appointment: item,
                        isSelected: _vm.selected.some(
                          (apt) => apt._id === item._id
                        ),
                        isExpanded: isExpanded,
                        isPharmacy: _vm.isPharmacy,
                        wfState: _vm.tab,
                        appointmentsInsideGroup:
                          _vm.expandedTableRows[item.group_id],
                      },
                      on: {
                        select: (isSelected) => _vm.select(isSelected, item),
                        "select-group": (isSelected) =>
                          _vm.selectGroup(
                            isSelected,
                            item,
                            ..._vm.expandedTableRows[item.group_id]
                          ),
                        expand: expand,
                        "update-by-id": (data) =>
                          _vm.updateById(item.group_id, data),
                        "update-appointments": _vm.updateAppointments,
                        delete: (payload) =>
                          _vm.deleteAppointment(
                            item.pharmacy.id,
                            item._id,
                            payload
                          ),
                        "fetch-appointments": _vm.refreshAppointmentsAndCounts,
                      },
                    }),
                  ]
                },
              },
              {
                key: "expanded-item",
                fn: function ({ item }) {
                  return _vm._l(
                    _vm.expandedTableRows[item.group_id],
                    function (appointment) {
                      return _c("TableRow", {
                        attrs: {
                          appointment: appointment,
                          isSelected: _vm.selected.some(
                            (apt) => apt._id === appointment._id
                          ),
                          isExpanded: _vm.expanded.some(
                            (apt) => apt._id === item._id
                          ),
                          isPharmacy: _vm.isPharmacy,
                          wfState: _vm.tab,
                        },
                        on: {
                          select: (isSelected) =>
                            _vm.select(isSelected, appointment),
                          delete: (payload) =>
                            _vm.deleteAppointment(
                              item.pharmacy.id,
                              appointment._id,
                              payload
                            ),
                          "update-by-id": (data) =>
                            _vm.updateById(item.group_id, data),
                          "fetch-appointments":
                            _vm.refreshAppointmentsAndCounts,
                        },
                      })
                    }
                  )
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "footer text-center pt-2" },
            [
              _vm.selected.length
                ? _c("BatchUpdateAppointments", {
                    attrs: {
                      selectedCount: _vm.selected.length,
                      tab: _vm.tab,
                      pharmacy_id: _vm.pharmacy_id,
                      isUngroupingEnabled: _vm.isUngroupingEnabled,
                      selectedAppointmentsIds: _vm.selectedAppointmentsIds,
                      selectedAppointmentsPriceOverrides:
                        _vm.selectedAppointmentsPriceOverrides,
                      canConfirmNonbinding: _vm.canConfirmNonbinding,
                    },
                    on: {
                      grouping: function ($event) {
                        _vm.isGroupDialogOpen = true
                      },
                      confirm: _vm.confirm,
                      "send-to-apobilanz": _vm.onMoveToApobilanz,
                      "batch-update": _vm.batchUpdateAppointments,
                      "batch-remove": _vm.batchDeleteAppointments,
                      "fetch-appointments": _vm.fetchAppointments,
                      "confirm-nonbinding":
                        _vm.batchConfirmNonBindingAppointments,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-row",
                { staticClass: "pagination-footer" },
                [
                  _c(
                    "v-col",
                    { staticClass: "d-flex align-center justify-center" },
                    [
                      _vm._v(
                        "\n                    Zeilen pro Seite:\n                    "
                      ),
                      _c("v-select", {
                        staticClass: "pt-0 ml-2 mt-0 mr-5",
                        attrs: {
                          items: [5, 10, 25, 50, 100],
                          placeholder: "Zeilen pro Seite",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.tableOptions.itemsPerPage,
                          callback: function ($$v) {
                            _vm.$set(_vm.tableOptions, "itemsPerPage", $$v)
                          },
                          expression: "tableOptions.itemsPerPage",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-pagination", {
                        attrs: {
                          length: Math.ceil(
                            _vm.appointmentsCount /
                              _vm.tableOptions.itemsPerPage
                          ),
                          "total-visible": 11,
                        },
                        model: {
                          value: _vm.tableOptions.page,
                          callback: function ($$v) {
                            _vm.$set(_vm.tableOptions, "page", $$v)
                          },
                          expression: "tableOptions.page",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isGroupDialogOpen
        ? _c("AddToGroup", {
            attrs: { groupAppointments: _vm.groupAppointments },
            on: { "add-group": _vm.addToGroup },
            model: {
              value: _vm.isGroupDialogOpen,
              callback: function ($$v) {
                _vm.isGroupDialogOpen = $$v
              },
              expression: "isGroupDialogOpen",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ConfirmationDialog",
        {
          attrs: { message: _vm.confirmationMessage },
          on: {
            save: function ($event) {
              _vm.confirmationType === "ungroup"
                ? _vm.removeFromGroup()
                : _vm.rebuildGroupAndMoveToApobilanz()
            },
          },
          model: {
            value: _vm.isConfirmDialogOpen,
            callback: function ($$v) {
              _vm.isConfirmDialogOpen = $$v
            },
            expression: "isConfirmDialogOpen",
          },
        },
        [
          _vm.confirmationType === "regroup"
            ? _c(
                "ul",
                { staticClass: "pt-0 pb-0" },
                _vm._l(_vm.selected, function (appointment) {
                  return _c(
                    "li",
                    {
                      key: appointment._id,
                      staticClass: "font-weight-bold subtitle-1 mt-2",
                      attrs: { dense: "" },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            appointment.date.split("-").reverse().join(".")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-4" }, [
                        _vm._v(_vm._s(appointment.display_time)),
                      ]),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }